/**
 * #001848 — TÊN NGẮN GỌN của nhân viên: chỉ lấy TÊN, bỏ họ và chữ lót.
 *
 * Dùng cho những chỗ chật chỗ (chip ca đề xuất ở lịch tuần) — góp ý gốc: "hiển thị tên ngắn gọn
 * bằng tên thôi không cần họ hay là chữ viết đệm".
 *
 * Tên người Việt viết xuôi (họ trước, tên sau) nên TÊN là mảnh chữ CUỐI CÙNG: "Nguyễn Thị Mỹ
 * Tiên" -> "Tiên". Không tách được (rỗng/1 mảnh) thì trả về nguyên chuỗi đã trim.
 */
export function getShortName(fullName) {
  const parts = String(fullName || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length === 0) return '';
  return parts[parts.length - 1];
}

/**
 * Chữ cái đầu cho ô ảnh đại diện: chữ đầu của HỌ và TÊN ("Nguyễn Văn An" -> "NA").
 * Không có tên thì trả "?".
 */
export function getAvatarInitials(fullName) {
  const parts = String(fullName || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length === 0) return '?';
  const first = parts[0][0];
  return (parts.length > 1 ? first + parts[parts.length - 1][0] : first).toUpperCase();
}

export default getShortName;
